import { ApplicationConfig, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { HttpClient, provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNzI18n, ru_RU, kk_KZ } from 'ng-zorro-antd/i18n';
import { routes } from './app.routes';
import {provideNzIcons} from "ng-zorro-antd/icon";
import { UserOutline } from '@ant-design/icons-angular/icons';
import { LockOutline } from '@ant-design/icons-angular/icons';
import { CheckCircleFill } from '@ant-design/icons-angular/icons';
import { MenuOutline } from '@ant-design/icons-angular/icons';
import { ClockCircleOutline } from '@ant-design/icons-angular/icons';
import { FileSearchOutline } from '@ant-design/icons-angular/icons';
import { TeamOutline } from '@ant-design/icons-angular/icons';
import { LogoutOutline } from '@ant-design/icons-angular/icons';
import { MoreOutline } from '@ant-design/icons-angular/icons';
import { SafetyCertificateOutline } from '@ant-design/icons-angular/icons';
import { GlobalOutline } from '@ant-design/icons-angular/icons';
import { FileProtectOutline } from '@ant-design/icons-angular/icons';
import {httpHandlerInterceptor} from "./core/interceptors/http-handler-interceptor";
import { TranslateService, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { catchError, of } from 'rxjs';

function resolveSavedLang(): 'ru' | 'kz' {
  const stored = typeof localStorage !== 'undefined' ? localStorage.getItem('lang') : null;
  const lang = stored?.toLowerCase() === 'kz' ? 'kz' : 'ru';
  if (typeof localStorage !== 'undefined' && stored !== lang) {
    localStorage.setItem('lang', lang);
  }
  return lang;
}

const savedLang = resolveSavedLang();

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    provideNzIcons([
      UserOutline, LockOutline, CheckCircleFill,
      MenuOutline, ClockCircleOutline, FileSearchOutline, TeamOutline, LogoutOutline, MoreOutline,
      SafetyCertificateOutline, GlobalOutline, FileProtectOutline,
    ]),
    provideNzI18n(savedLang === 'kz' ? kk_KZ : ru_RU),
    provideHttpClient(
      withInterceptors([httpHandlerInterceptor]),
      withXsrfConfiguration({ cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN' })
    ),
    provideTranslateService({
      loader: provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
      fallbackLang: 'ru',
      lang: savedLang
    }),
    provideAppInitializer(() => inject(TranslateService).use(savedLang)),
    provideAppInitializer(() =>
      inject(HttpClient).get('/api/sso/SsoFlow/antiforgery/token').pipe(catchError(() => of(null))))
  ]
};
